import { format, parse } from 'date-fns';

export const formatTimeDisplay = (time: string): string => {
  if (!time) return '';
  
  try {
    // Input is in 24-hour format (HH:mm)
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    
    return format(date, 'h:mm a');
  } catch {
    return '';
  }
};

export const parseTimeForStorage = (time24h: string): string => {
  if (!time24h) return '';
  
  try {
    const [hours, minutes] = time24h.split(':').map(num => parseInt(num, 10));
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  } catch {
    return '';
  }
};